/**
 * The original site set a different <body> ground per page. Only Experience
 * runs dark; everything else runs on bone. Resolved from the pathname so the
 * class can be set during SSR (no flash) and again on client-side navigation.
 */
const DARK_PATHS = ["/experience"]

export function bodyClassForPath(pathname = "/") {
  const path = pathname.replace(/\/+$/, "") || "/"
  return DARK_PATHS.includes(path) ? "theme-dark" : "theme-light"
}
